var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _circle, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 32,
    viewBox: "0 0 119 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 21.8866H43.3981V9.07214H41V21.8866Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.964 20.2756C55.6461 21.5753 53.9435 22.1794 52.0943 22.1794C47.3346 22.1794 45.3209 18.9026 45.3028 15.571C45.2846 12.221 47.4628 8.81567 52.0943 8.81567C53.8336 8.81567 55.4814 9.47469 56.7995 10.7745L55.1882 12.3306C54.3463 11.5071 53.2115 11.1225 52.0943 11.1225C49.0007 11.1225 47.6643 13.4291 47.6829 15.571C47.7009 17.6946 48.9276 19.9098 52.0943 19.9098C53.2115 19.9098 54.4743 19.4521 55.3166 18.61L56.964 20.2756Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5545 15.9001H64.1792C67.2728 15.9001 67.2547 11.3599 64.1792 11.3599H60.5545V15.9001ZM64.1792 18.1154H60.5544V21.8864H58.1379V9.07195C60.1518 9.07195 62.1655 9.05371 64.1792 9.05371C70.44 9.05371 70.4582 18.1154 64.1792 18.1154Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4238 12.1659C77.9848 11.4335 76.7762 10.738 75.3852 10.738C73.591 10.738 72.7306 11.4884 72.7306 12.4406C72.7306 13.5571 74.0485 13.8685 75.5866 14.0516C78.2593 14.3811 80.7487 15.0765 80.7487 18.1336C80.7487 20.9895 78.2223 22.2162 75.3665 22.2162C72.7489 22.2162 70.735 21.4109 69.7834 19.0675L71.7967 18.0239C72.3643 19.4334 73.8472 20.056 75.4033 20.056C76.9227 20.056 78.3507 19.5251 78.3507 18.1336C78.3507 16.9256 77.0875 16.4311 75.3852 16.2481C72.7669 15.9371 70.3506 15.2415 70.3506 12.3673C70.3506 9.73087 72.9502 8.65113 75.3116 8.63257C77.3071 8.63257 79.3758 9.20021 80.3463 11.1769L78.4238 12.1659Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5635 12.8431L92.5405 19.6346L94.6091 12.8431H97.0806L93.9315 21.9234H91.3321L90.3986 19.2507L89.5933 16.2299L88.7874 19.2507L87.8539 21.9234H85.2544L82.0872 12.8431H84.5773L86.6455 19.6346L88.6048 12.8431H90.5635Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.861 20.0878C100.452 20.0878 99.3046 18.9407 99.3046 17.5308C99.3046 16.1213 100.452 14.9742 101.861 14.9742C103.271 14.9742 104.418 16.1213 104.418 17.5308C104.418 18.9407 103.271 20.0878 101.861 20.0878ZM104.441 13.5086C103.669 13.0123 102.779 12.7505 101.861 12.7505C99.2252 12.7505 97.0806 14.8953 97.0806 17.531C97.0806 20.1671 99.2252 22.3117 101.861 22.3117C102.779 22.3117 103.669 22.0498 104.441 21.5536V22.1271H106.642V12.9164H104.441V13.5086Z",
    fill: "#212121"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 12,
    width: 11,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.133 12.7411H118.113V25.7502H108.133V12.7411Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.332 20.0783C111.922 20.0783 110.775 18.9313 110.775 17.5214C110.775 16.1117 111.922 14.9648 113.332 14.9648C114.742 14.9648 115.889 16.1117 115.889 17.5214C115.889 18.9313 114.742 20.0783 113.332 20.0783ZM113.332 12.7411C112.244 12.7411 111.183 13.1175 110.334 13.8032V12.9619H108.133V25.7502H110.334V21.2401C111.183 21.9259 112.244 22.3023 113.332 22.3023C115.968 22.3023 118.113 20.1575 118.113 17.5216C118.113 14.8859 115.968 12.7411 113.332 12.7411Z",
    fill: "#212121"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9707 7.19995C17.4803 7.19995 15.6815 9.19203 15.2017 10.5987C14.3601 12.7632 14.7154 14.4259 15.0285 15.8922L15.0512 15.999C15.3419 17.3627 15.6163 18.6507 15.2234 20.2673C15.1869 20.4886 15.1221 20.7062 15.0307 20.9142C14.5812 21.9451 13.5617 22.6108 12.4338 22.6108C10.8728 22.6108 9.60277 21.3484 9.60277 19.7964C9.60277 18.2436 10.8728 16.9804 12.4338 16.9804C12.8542 16.9804 13.2582 17.0705 13.6355 17.2477L13.9643 17.4024L13.5546 14.9126L13.4253 14.8867C13.101 14.8218 12.7673 14.7891 12.4338 14.7891C9.65803 14.7891 7.3999 17.0353 7.3999 19.7964C7.3999 22.5576 9.65803 24.8036 12.4338 24.8036C14.7381 24.8036 16.7435 23.2538 17.3075 21.0474C17.8778 19.3192 17.6112 17.7424 17.2333 16.0071L17.1911 15.814C16.8203 14.1169 16.5273 12.7763 17.4106 11.0062C17.8756 10.0259 18.8803 9.39231 19.9707 9.39231C21.531 9.39231 22.8007 10.6547 22.8007 12.2068C22.8007 13.7587 21.531 15.0217 19.9707 15.0217C19.5838 15.0217 19.2081 14.9453 18.8528 14.794L18.5334 14.6583L18.9368 17.1101L19.0695 17.1342C19.3643 17.1872 19.6676 17.2144 19.9707 17.2144C22.7458 17.2144 25.0035 14.9679 25.0035 12.2068C25.0035 9.44597 22.7458 7.19995 19.9707 7.19995Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.264463,
    y1: 15.1351,
    x2: 29.2813,
    y2: 14.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5569DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8572FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.3e0cd9be6a0e52b49b72c67e9486d930.svg";
export { ForwardRef as ReactComponent };